import React from 'react';
import logo from './../../../assets/image/logo.jpg';
import browser from './../../../assets/image/browser.png';
import facebook from './../../../assets/image/facebook.png';
import linkedin from './../../../assets/image/linkedin.png';
// import ibpap from './../../../assets/image/ibpap.jpg';
import { formatedCvData } from '../../../utils/types';

interface cvData {
    data : formatedCvData | null;
}

const CvHeader : React.FC = () => {
    return (
        <div className='flex gap-2'>
            <div className='flex flex-col gap-2 my-5 w-full'>
                <div className='flex gap-2 items-center'>
                    <div className='max-w-5'>
                        <img src={browser} alt="browser" />
                    </div>
                    <small className='underline'>
                        http://www.vcclink.com
                    </small>
                </div>
                <div className='flex gap-2 items-center'>
                    <div className='max-w-5'>
                        <img src={facebook} alt="browser" />
                    </div>
                    <small className='underline'>
                        https://www.facebook.com/VCCLink
                    </small>
                </div>
                <div className='flex gap-2 items-center'>
                    <div className='max-w-5'>
                        <img src={linkedin} alt="browser" />
                    </div>
                    <small className='underline'>
                        https://www.linkedin.com/company/vcc-link/mycompany/
                    </small>
                </div>
                <div className='bg-orange-300 p-0.5 w-full'></div>
            </div>
            <div className='ms-auto'>
                <div className='max-w-32 mt-4'>
                    <img src={logo} alt="" />
                </div>
                
            </div>
        </div>
    );
}

const CvFooter : React.FC = () => {
    return(
        <div className='mb-2 mt-auto text-gray-400'>
            <div className='border '></div>
            <div className='flex'>
                <div>
                    <div className='flex flex-col'>
                        <small className='text-xs'>1- VCC LINK</small>
                        {/* <small className='text-xs'>IBPAP MEMBER</small> */}
                    </div>
                </div>
                {/* <div className='ms-auto'>
                    <img src={ibpap} alt="ibpap" />
                </div> */}
            </div>
        </div>
    )
}

const CvTemplate : React.FC<cvData> = ({ data }) => {

    return (
        <div className="flex flex-col gap-4 shadow-xl bg-white w-[52rem] min-h-[55rem] p-8">
            <CvHeader />
            <div className='h-full w-full p-2'>
                <div className='mb-3'>
                    <h1 className='uppercase underline text-blue-700 font-bold text-[29px]'>
                        {data ? data.cdd_name : 'CDD Fullname'}
                    </h1>
                </div>
                <div className='mb-3'>
                    <h3 className='uppercase font-semibold'>PROFESSIONAL SUMMARY:</h3>
                    <div>
                        {data?.profile_summary}
                    </div>
                </div>
                <div className='mb-3'>
                    <h3 className='uppercase font-semibold'>EMPLOYMENT BACKGROUND:</h3>
                    <div className='px-5'>
                        {data?.exp.map((exp)=>(
                            <div>
                                <h1 className='font-semibold'>{exp.company}</h1>
                                <h1 className='font-semibold'>{exp.position}</h1>
                                <h1 className='font-semibold'>{exp.duration}</h1>
                                <div>
                                    {exp.accomplishment.map((task)=>(
                                        <div className='flex gap-2 ms-5'>
                                            <p>•</p> <p>{task}</p>
                                        </div>                       
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='mb-3'>
                    <h3 className='uppercase font-semibold'>EDUCATIONAL BACKGROUND:</h3>
                    <div>
                    {data?.educ_background.map((data)=>(
                        <div>
                            <h1 className='font-semibold'>{data.university}</h1>
                            {data.achievements.map((achievement)=>(
                                <>
                                    <p className='px-5'>• {achievement}</p>
                                </>
                            ))}
                        </div>
                    ))}
                    </div>
                    
                </div>
                <div className='mb-3'>
                    <h3 className='uppercase font-semibold'>SKILLS:</h3>
                    <div className='px-5'>
                        {data?.expertise.map((expertise)=>(
                            <p>
                                • {expertise}
                            </p>
                        ))}
                    </div>
                </div>
                <div className='mb-3'>
                    <h3 className='uppercase font-semibold'>CERTIFICATIONS:</h3>
                    <div className='px-5'>
                        {data?.certifications.map((cert)=>(
                            <p>
                                • {cert}
                            </p>
                        ))}
                    </div>
                </div>
                <div className='mb-3'>
                    <h3 className='uppercase font-semibold'>AWARDS:</h3>
                    <div className='px-5'>
                        {data?.awards.map((award)=>(
                            <p>
                                • {award}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
            <CvFooter />
        </div>
    );
}

export default CvTemplate;